/* eslint-disable @typescript-eslint/member-ordering */
import { Component } from '@angular/core';
import { ButtonComponent } from '../../../shared/components/button/button.component';
import { ListHeaderComponent } from '../../../shared/components/list-header/list-header.component';
import { InputComponent } from '../../../shared/components/input/input.component';
import { FormArray, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Crud } from '../../../shared/services/crud/crud';
import { TooltipModule } from 'primeng/tooltip';
import { NgForOf } from '@angular/common';
import { CrudContainerComponent } from '../../../shared/components/crud-container/crud-container.component';
import { UserService } from '../../../shared/services/user2/user.service';
import { SelectComponent } from '../../../shared/components/select/select.component';
import { SelectConfig } from '../../../shared/components/select/models/select.config';
import { CheckboxModule } from 'primeng/checkbox';
import { PaginationDto } from '../../../shared/services/pagination/models/interfaces/pagination-dto';
import { Api } from '../../../shared/services/api/api';
import { User } from '../../../shared/models/interfaces/user.interface';
import { environment } from '../../../../environments/environment';

interface UserForm {
  name: FormControl<string>;
  roles: FormArray<FormGroup<RolesForm>>
}

interface RolesForm {
  permission: FormControl<string>;
  userId: FormControl<number>;
}

@Component({
    imports: [
        ButtonComponent,
        ListHeaderComponent,
        InputComponent,
        ReactiveFormsModule,
        TooltipModule,
        NgForOf,
        CrudContainerComponent,
        SelectComponent,
        CheckboxModule,
    ],
    templateUrl: './crud.component.html',
    providers: [Api]
})
export class CrudComponent extends Crud<UserForm> {

  constructor(
    private readonly apiService: Api,
    private readonly userService: UserService,
  ) {
    super();
  }

  public async test(): Promise<void> {
    this.apiService.get(
      `${environment.apiUrl}/users`,
      {
        headers: {
          'Authorization': 'Bearer 123456789'
        },
        cancelInterceptors: true,
        abortKey: 'users_key',
      }).subscribe(e => {
        console.log(e);
      });
  }

  public cancel(): void {
    this.apiService.abort('users_key');
  }

  public override form = new FormGroup<UserForm>(<UserForm>{
    name: new FormControl('', [Validators.required]),
    roles: new FormArray<FormGroup<RolesForm>>([]),
  });

  public addRole(): void {
    const rolesArray = this.form.get('roles') as FormArray;
    rolesArray.push(
      new FormGroup<RolesForm>(<RolesForm>{
        permission: new FormControl('', [Validators.required]),
        userId: new FormControl(0),
      })
    );

    this.tap();
  }

  public override mapField = {
    name: 'Nome',
  };

  public override async initialize(): Promise<void> {
    if (!this.isUpdate || !this.id)
     return;

    const user = await this.userService.getOne(this.id);

    if (!user)
      return;

    this.form.patchValue({
      name: user.name,
    });
  }

  public async submit(): Promise<void> {
    const payload = this.form.getRawValue() as any;

    if (this.isUpdate)
      await this.userService.update(this.id!, payload);

    await this.userService.create(payload);
  }

  public config: SelectConfig<User> = {
    load: async (page?: number, search?: string): Promise<PaginationDto<User>> => {
      return await this.userService.getMany({
        page,
        limit: 10,
        search: {
          $and: [
            ...search ? [{ name: { $contL: search } }] : [],
          ]
        }
      });
    }
  }

}
